import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { getNames } from 'country-list';
import TosDialog from './TosDialog';
import Checkbox from 'material-ui/Checkbox';

const flexItem = {
  minWidth: 300,
  margin: '0 20px'
}

class RegistrationForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      country: null,
      organizationType: null,
      tosOpen: false,
      newsletterSignUp: false
    };
  }

  componentDidMount() {
    if (this.props.validate) {
      let errors = this.validate();
      if (errors) {
        this.setState(errors);
      }
    }
  }

  handleCountryChange = (e, i, v) => {
    this.setState({country: v});
  }

  handleOrganizationTypeChange = (e, i, organizationType) => {
    this.setState({organizationType});
  }

  render() {

    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.props.onRequestClose}
      />,
      <RaisedButton label="Create an Account" primary={true} disabled={this.props.submitting} onClick={this.handleSubmit} />
    ];

    var newsletterErrorStyle = {
      color: this.state.newsletterError && this.state.newsletterError.length > 0 ? "red" : "black",
      fontWeight: this.state.newsletterError && this.state.newsletterError.length > 0 ? "bold" : "normal"
    }

    return (
      <Dialog open={this.props.open} title="Create an Account" onRequestClose={this.props.onRequestClose} actions={actions} autoScrollBodyContent>
        <br />
        Provide the following details to create an account. After submitting, you will receive a confirmation email. You must click the link to complete your registration before you can sign in. Please email support@fishpath.org if you experience any difficulties registering and a member of our team will reply within 1 week.
        <br />
        <div style={{
          display: 'flex',
          justifyContent: 'left',
          flexWrap: 'wrap'
        }}>
        <div style={flexItem}>
        <TextField
          ref="email"
          floatingLabelText="Email *"
          defaultValue={this.props.email}
          type="text"
          errorText={this.state.emailError}
        />
        <br />
        <TextField
          ref="password"
          floatingLabelText="Password *"
          type="password"
          defaultValue={this.props.password}
          onKeyDown={this.handleKeyDown}
          errorText={this.state.passwordError}
        />
        <br />
        <TextField
          ref="name"
          floatingLabelText="Your Name *"
          defaultValue={this.props.name}
          type="text"
          errorText={this.state.nameError}
        />
        </div>
        <br />
        <div style={flexItem}>
        <SelectField
          floatingLabelText="Organization Type *"
          ref="organizationType"
          value={this.state.organizationType}
          onChange={this.handleOrganizationTypeChange}
          errorText={this.state.organizationTypeError}
        >
          <MenuItem value="government" primaryText="Government" />
          <MenuItem value="academic" primaryText="Academic Institution" />
          <MenuItem value="ngo" primaryText="NGO" />
          <MenuItem value="other" primaryText="Other" />
        </SelectField>
        <br />
        <TextField
          ref="organization"
          floatingLabelText="Organization"
          defaultValue={this.props.organization}
          type="text"
        />
        <br />
        <SelectField
          errorText={this.state.countryError}
          floatingLabelText="Country *"
          ref="country"
          onChange={this.handleCountryChange}
          value={this.state.country}
          menuStyle={{width: 375}}
          style={{width: 256}}
          iconStyle={{left: 256 - 48}}
        >
          {
            getNames().map((name) => <MenuItem key={name} value={name} primaryText={name} />)
          }
        </SelectField>
        </div>
        </div>

        <Checkbox checked={this.state.newsletterSignUp} onCheck={this.onNewsletterCheck.bind(this)} labelStyle={{fontSize:14, lineHeight:"14px"}} label={<div><span style={newsletterErrorStyle}>(Required)</span> The FishPath team may send periodic communications to Tool account holders informing users about changes to the Tool or other relevant updates. By checking this box you agree to receive the FishPath Tool Newsletter and other email communications from FishPath. You may unsubscribe from this list by following the instructions in the Newsletter at any time. Unsubscribing will not remove your access to the FishPath Tool.</div>} />
        <p>
        By submitting your registration request, providing your registration information, and accessing and using the FishPath Tool and instructions, you are agreeing to our <a  href="javascript:;" onClick={() => this.setState({tosOpen: true})}>Terms of Service</a> and granting The Nature Conservancy the right to use your submission to further our conservation mission. This may include evaluation of responses and results for guiding improvements to the Tool and publication of scientific manuscripts.  All aggregation of data will be kept anonymous and will not be attributed to individuals or organizations, unless permission is granted to The Nature Conservancy by the willing party.
        </p>
        { this.props.error ? <div style={{color: "red", marginTop: 20}}>{this.props.error}</div> : null}
        { this.state.tosOpen && <TosDialog open={true} dismissable={true} onDismiss={() => this.setState({tosOpen: false})} /> }
      </Dialog>
    )
  }

  onNewsletterCheck(){
    this.setState({
      newsletterSignUp: !this.state.newsletterSignUp
    })
  }

  hasRequired = (attr) => {
    let str = this.refs[attr].getValue()
    return str && str.length > 0
  }

  validate = () => {
    let errors = {
      passwordError: "",
      emailError: "",
      nameError: "",
      organizationTypeError: "",
      countryError: "",
      newsletterError: ""
    };
    let failed = false;

    if (!this.hasRequired('password')) {
      errors.passwordError = 'Required';
      failed = true;
    }
    if (!this.hasRequired('email')) {
      errors.emailError = 'Required';
      failed = true;
    }
    if (!this.hasRequired('name')) {
      errors.nameError = 'Required';
      failed = true;
    }
    if (!this.state.organizationType) {
      errors.organizationTypeError = 'Required';
      failed = true;
    }
    if (!this.state.country) {
      errors.countryError = 'Required';
      failed = true;
    }
    if(!this.state.newsletterSignUp){
      errors.newsletterError = 'Required';
      failed = true;
    }
    if (failed) {
      return errors;
    } else {
      return false;
    }
  }

  handleSubmit = () => {
    let errors = this.validate();
    if (errors) {
      this.setState(errors);
    } else {
      if (this.props.onSubmit) {
        this.props.onSubmit({
          password: this.refs.password.getValue(),
          email: this.refs.email.getValue(),
          name: this.refs.name.getValue(),
          organization: this.refs.organization.getValue(),
          organizationType: this.state.organizationType,
          country: this.state.country
        })
      }
    }
  }

  handleKeyDown = (e, key) => {
    if (e.keyCode === 13) {
      this.handleSubmit()
    }
  }

}

RegistrationForm.defaultProps = {
  open: true
}

export default RegistrationForm
